export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-widget-ee4e67bc16e8166b369977168a4e4f16.svg";